import type { KeyboardEvent } from 'react'

/**
 * `onKeyDown` for a non-button element acting as one (`role="button"`/`tabIndex={0}`):
 * Enter or Space activates it like a click. Keys from a nested control (a tab's close
 * button, a row's checkbox) are ignored so that control keeps its own activation, and
 * Space's default page scroll is suppressed.
 */
export function onActivateKey(activate: () => void) {
  return (event: KeyboardEvent<HTMLElement>) => {
    if (event.target !== event.currentTarget) return
    if (event.key !== 'Enter' && event.key !== ' ') return
    event.preventDefault()
    activate()
  }
}
